import { HYDRATE_STATE } from "commons/src/reducers/indexActions";
import { IN_PROGRESS, DONE, FAILED } from "commons/src/helpers/RequestHelpers";

import { SAVE_LINKS } from "./requestsActions";

export const requests = (state = {}, action) => {
    switch (action.type) {
        case IN_PROGRESS:
            return {
                ...state,
                [action.requestData]: {
                    ...state[action.requestData],
                    numberOfRetries:
                        (state[action.requestData] &&
                            state[action.requestData].numberOfRetries + 1) ||
                        0,
                    status: IN_PROGRESS
                }
            };

        case DONE:
            return {
                ...state,
                [action.requestData]: {
                    href: (state[action.requestData] && state[action.requestData].href) || "",
                    status: DONE
                }
            };

        case FAILED:
            return {
                ...state,
                [action.requestName]: {
                    ...state[action.requestName],
                    status: FAILED,
                    errorMessage: action.errorMessage,
                    errorCode: action.errorCode,
                    severity: action.severity
                }
            };

        case SAVE_LINKS: {
            return {
                ...state,
                ...action.links
            };
        }

        case HYDRATE_STATE:
            return { ...state, ...action.newState.requests };

        default:
            return state;
    }
};
